export const HotelsRoutes = {
    Base: '/hotels',
    Details: ':id',
    RegisterHotel: 'register-building',
};
